import moment from "moment";
import { ISearchLimitOffset } from "./ISearchLimitOffset";

export interface IFilterFichiersAlertePoches extends ISearchLimitOffset {
    Id?: number;
    Nom?: string;
    PeriodeDateDebut?: Date;
    PeriodeDateFin?: Date;
    DateCreation?: Date;
    SortField?: string;
    IsDescending?:boolean;
  }

  export interface IFilterFichiersAlertePochesDTO extends ISearchLimitOffset {
    Id: number;
    Nom: string;
    PeriodeDateDebut: string;
    PeriodeDateFin: string;
    DateCreation: string;
    SortField: string;
    IsDescending:boolean;
}
  
  export const getDefaultFilterFichiersAlertePoches = (): IFilterFichiersAlertePoches => ({
    Id: undefined,
    Nom: undefined,
    PeriodeDateDebut: undefined,
    PeriodeDateFin: undefined,
    DateCreation: undefined,
    Limit: 10,
    Offset: 0,
    SortField: "Nom",
    IsDescending: true
  });

  export const dtoToFilter = (dto: IFilterFichiersAlertePochesDTO): IFilterFichiersAlertePoches => {
  
    return {
        Id: dto.Id,
        Nom: dto.Nom,
        PeriodeDateDebut: dto.PeriodeDateDebut ? new Date(dto.PeriodeDateDebut) : undefined,
        PeriodeDateFin: dto.PeriodeDateFin ? new Date(dto.PeriodeDateFin) : undefined,
        DateCreation: dto.DateCreation ? new Date(dto.DateCreation) : undefined,
        Limit: dto.Limit !== undefined ? dto.Limit : 10,
        Offset: dto.Offset !== undefined ? dto.Offset : 0,
    };
  };

  export const filterToQuery = (filter: IFilterFichiersAlertePoches): IFilterFichiersAlertePochesDTO => {
    const dto: IFilterFichiersAlertePochesDTO = {
        Id: 0,
        Nom: "",
        PeriodeDateDebut: "",
        PeriodeDateFin: "",
        DateCreation: "",
        SortField: "",
        IsDescending: false
    };
 
    if (filter?.Id !== undefined ) {
      dto.Id = filter.Id;
    } 

    if (filter?.Nom !== undefined ) {
      dto.Nom = filter.Nom;
    } 


    if (filter.DateCreation) {
        if (filter.DateCreation instanceof Date) {
            // Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
            dto.DateCreation = moment(new Date(filter.DateCreation?.getFullYear(),filter.DateCreation?.getMonth(),filter.DateCreation?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        } else {
            dto.DateCreation = filter.DateCreation;
        }
        
    }
    if (filter.PeriodeDateDebut) {
        if (filter.PeriodeDateDebut instanceof Date) {
            //Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
            dto.PeriodeDateDebut = moment(new Date(filter.PeriodeDateDebut?.getFullYear(),filter.PeriodeDateDebut?.getMonth(),filter.PeriodeDateDebut?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        } else {
            dto.PeriodeDateDebut = filter.PeriodeDateDebut;
        }
    }
    if (filter.PeriodeDateFin) {
      if (filter.PeriodeDateFin instanceof Date) {
          //Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
          dto.PeriodeDateFin = moment(new Date(filter.PeriodeDateFin?.getFullYear(),filter.PeriodeDateFin?.getMonth(),filter.PeriodeDateFin?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
      } else {
          dto.PeriodeDateFin = filter.PeriodeDateFin;
      }
  }

    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }
  
    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }

    //localStorage.setItem("IFilterFichiersAlertePoches", JSON.stringify(dto));
  
    return dto;
  };